import React from "react";
import CustomizationForm from "./components/CustomizationForm";
import "./App.css";

function App() {
  return (
    <div className="App">
      <CustomizationForm />
    </div>
  );
}

export default App;
